import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AppDataProvider } from "@/context/AppData";
import { Header, Footer } from "@/components/site/Layout";
import Home from "@/pages/Home";
import Create from "@/pages/Create";
import Order from "@/pages/Order";
import GiftPage from "@/pages/Gift";
import { Occasions, Pricing, HowItWorks, Examples, FAQ, Legal } from "@/pages/Public";
import { Contact, Track } from "@/pages/Forms";
import { AdminAuthProvider, AdminLayout, AdminLogin } from "@/admin/AdminShell";
import { Overview, Orders } from "@/admin/Dashboard";
import OrderDetail from "@/admin/OrderDetail";
import { LanguagesAdmin, OccasionsAdmin, SettingsAdmin, RecordsAdmin } from "@/admin/Catalogs";

const PublicShell = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded focus:bg-white focus:px-4 focus:py-2">Skip to content</a>
      <Header />
      <div id="main"><Outlet /></div>
      <Footer />
    </>
  );
};

export default function App() {
  return (
    <AppDataProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicShell />}>
            <Route path="/" element={<Home />} />
            <Route path="/create" element={<Create />} />
            <Route path="/occasions" element={<Occasions />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/examples" element={<Examples />} />
            <Route path="/track" element={<Track />} />
            <Route path="/order/:token" element={<Order />} />
            <Route path="/gift/:token" element={<GiftPage />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/refunds" element={<Legal kind="refund" />} />
          </Route>
          <Route path="/admin" element={<AdminAuthProvider><Outlet /></AdminAuthProvider>}>
            <Route path="login" element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route index element={<Overview />} />
              <Route path="orders" element={<Orders />} />
              <Route path="orders/:id" element={<OrderDetail />} />
              <Route path="languages" element={<LanguagesAdmin />} />
              <Route path="occasions" element={<OccasionsAdmin />} />
              <Route path="settings" element={<SettingsAdmin />} />
              <Route path="records" element={<RecordsAdmin />} />
            </Route>
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AppDataProvider>
  );
}
